<template>
  <div
    id="login"
    class="login"
    v-loading="loading"
    :element-loading-text="$t('login.submitLogin')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <div class="login-wrapper">
      <!-- <div class="logo-txt">一恒科智能管理平台</div> -->
      <div class="logo-txt">
        {{$t('login.loginTitle')}}
        <span style="font-size: 15px">({{systemName}})</span>
      </div>

      <!-- 表单 -->
      <el-form class="login-form" ref="loginForm" :model="loginForm" :rules="loginFormRules">

        <!-- 用户名 -->
        <el-form-item prop="username">
          <el-input type="text" v-model="loginForm.username"  :placeholder="$t('login.placeholderLoginName')">
            <i slot="prefix" class="el-input__icon icon_user"></i>
          </el-input>
        </el-form-item>

        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input type="password" v-model="loginForm.password" :placeholder="$t('login.placeholderpassword')">
            <i slot="prefix" class="el-input__icon icon_pwd"></i>
          </el-input>
        </el-form-item>

        <!-- 登陆按钮 -->
        <el-form-item>
          <el-button ref="loginBtn" type="primary" @click="signIn('loginForm')" class="submit-btn" size="medium">{{$t('login.loginForm')}}</el-button>
        </el-form-item>

      </el-form>
    </div>
  </div>
</template>
<script>
import md5 from "md5";
import store from "../store";
export default {
  data() {
    return {
      loading: false,
      validCodeFlag: true,
      loginForm: { username: '', password: '',sysPath: '' },
      sysPath: '',
      loginFormRules: {
        username: [
          { required: true, message: this.$t('login.placeholderLoginName'), trigger: "blur" }
        ],
        password: [{ required: true, message: this.$t('login.placeholderpassword'), trigger: "blur" }],
      },
      serverRegion: null,
      systemName: null
    };
  },
  created() {
    let that = this;
    // 按 Enter 登入
    document.onkeyup = function(event) {
      let e = event || window.event;
      let keyCode = e.keyCode || e.which; // 按键的keyCode
      if (keyCode === 13) that.signIn("loginForm");
    };

    if(window.location.hostname.indexOf("imsmanage") !=-1 || window.location.hostname.indexOf("44.204.135.3") !=-1) {
      this.systemName = "美国"
      window.sessionStorage.systemName = "(美国)"
    }else if (window.location.hostname.indexOf("eumanage") !=-1 || window.location.hostname.indexOf("3.71.4.189") !=-1) {
      this.systemName = "欧洲"
      window.sessionStorage.systemName = "(欧洲)"
    }else if (window.location.hostname.indexOf("121.42.13.29") !=-1 || window.location.hostname.indexOf("47.242.135.72") !=-1) {
      this.systemName = "测试"
      window.sessionStorage.systemName = "(测试)"
    }else {
      this.systemName = "本地"
      window.sessionStorage.systemName = "(本地)"
    }
  },
  methods: {
    signIn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.$axiosPost(this.$api.loginapi, {
            loginName: this.loginForm.username,
            passwd: md5(this.loginForm.password)
          }).then(res => {
            if (res.code === this.http.OK) {
              let token = res.data.token;
              window.sessionStorage.token = token;
              window.sessionStorage.userName = res.data.userName;
              window.sessionStorage.userLogin = res.data.sysLogin;
              window.sessionStorage.roleId = res.data.roleId
              this.$axiosPost(this.$api.getLoginUserInfoApi,{projectId: 0}).then(r => {
                if (r.code === this.http.OK) {
                  this.userType = r.data.userType
                  if (this.userType === 4) { // 当用户类型是4客户时，跳转特定页
                    this.$router.push({path: '/virtualSnListView', query: {id: r.data.id}})
                  }else {
                    this.$router.replace('/home');
                  }
                }
              })
            } else {
              this.loading = false;
              this.$notify.error({ message: res.msg });
            }
          })
        }
      })
    },
    goLinkPage() {
      window.open("http://eumanage.efercro.com/", "_blank")
    }
  }
};
</script>

<style lang=less>
.el-button--medium {
  width: 150px;
}
.login {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: url("../images/login_bg.png") center no-repeat;
  background-size: cover;

  .login-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 20px;
    width: 420px;
    margin-top: -130px;
    margin-left: -240px;
    background-color: rgba(47,90,227,.3);
    border-radius: 5px;

    .logo-txt {
      font-size: 2rem;
      color: #fff;
      z-index: 8888;
      padding-bottom: 30px;
    }
    .login_txt {
      color: #fff;
    }
  }
  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    color: #fff;
  }
  input:-moz-placeholder,
  textarea:-moz-placeholder {
    color: #fff;
  }
  input::-moz-placeholder,
  textarea::-moz-placeholder {
    color: #fff;
  }
  input:-ms-input-placeholder,
  textarea:-ms-input-placeholder {
    color: #fff;
  }
  .el-input__icon {
    width: 40px;
    display: inline-block;
  }
  .icon_user {
    background: url("../images/icon_user.png") no-repeat;
    background-position: 2px 5px;
  }
  .icon_pwd {
    background: url("../images/icon_pwd.png") no-repeat;
    background-position: 2px 5px;
  }
  .icon_sys {
    background: url("../images/icon_verify.png") no-repeat;
    background-position: 2px 5px;
  }
  input:-webkit-autofill {
    background-color: #042993;
    color: #fff;
  }
  .el-input__inner {
    height: 40px;
    background-color: rgba(17, 23, 116, 0.7);
    color: #fff;
    border: 0;
    padding-left: 35px !important;
  }
  .el-button-submit {
    margin-left: 55px;
    font-size: 18px;
    width: 135px;
    margin: 0, auto;
  }
  .submit-btn{
    font-size: 18px;
    font-weight: bold;
    border:none;
    background-color: rgba(17, 23, 116, 0.7);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue